import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { IVideo, VideoUtils } from '../models/video.model';
import { AuthService } from '../auth/auth.service';
import { ProfileService } from '../auth/profile.service';
import { IDataArray, IRemoteReference } from '../models/data-array.model';
import { environment } from '../../environments/environment';

@Injectable()
export class VideoService {

    get headers(): HttpHeaders {
        let headers: HttpHeaders = new HttpHeaders();
        headers = this.auth.addAuthHttpHeaders(headers);
        headers = this.profile.addProfileHttpHeaders(headers);
        return headers;
    }

    constructor(
        private http: HttpClient,
        private auth: AuthService,
        private profile: ProfileService,
    ) { }

    getAll(): Observable<IDataArray<IVideo>> {
        let url: string = environment.apiEndpoint + '/videos';
        return this.http.get<IDataArray<IVideo>>(url, { headers: this.headers });
    }

    getById(id: string): Observable<IVideo> {
        let url: string = environment.apiEndpoint + '/videos/' + id;
        return this.http.get<IVideo>(url, { headers: this.headers });
    }

    create(video: IVideo): Observable<IRemoteReference<IVideo>> {
        let url: string = environment.apiEndpoint + '/videos';
        return this.http.post<IRemoteReference<IVideo>>(url, video, { headers: this.headers });
    }

    update(video: IVideo): Observable<void> {
        let url: string = environment.apiEndpoint + '/videos/' + video.id;
        return this.http.put<void>(url, video, { headers: this.headers });
    }

    delete(id: string): Observable<void> {
        let url: string = environment.apiEndpoint + '/videos/' + id;
        return this.http.delete<void>(url, { headers: this.headers });
    }
}
